export enum APIRoutes {
  ACCOUNT = 'account',
  SALE_ORDERS = 'sale-orders',
  PAYMENTS = 'payments',
  DASHBOARD = 'dashboard',
  CLIENTS = 'clients',
  CLIENTS_ALIASES = 'Clients/aliases',
}
